module.exports = __webpack_public_path__ + "static/media/wheel.1e7598d7.png";